import React from 'react';
import { Form, DatePicker, TimePicker, Input, Select, InputNumber, Row, Col } from "antd";
// import "./index.css";
import CitySelect from "../antdFormContent/citySelect";
// import GameRole from "../antdFormContent/gameRole";
import UploadDragger from "../antdFormContent/uploadDragger";
import PhoneCodeButton from "./phoneCodeButton";

const AntdFormContent = (item, index, form) => {
    switch (Number(item.type)) {
        /* date input */
        case 1:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请选择日期' }]}
            >
                <DatePicker placeholder={item.desc} inputReadOnly={true} style={{ width: '100%' }} />
            </Form.Item>
        /* date + time */
        case 2:
            return <Form.Item
                key={index}
                label={item.name}
                required={item.required}
            >
                <Row gutter={[16, 16]}>
                    <Col span={12} >
                        <Form.Item
                            name={[index, 'date']}
                            rules={[{ required: item.required, message: '请选择日期' }]}
                        >
                            <DatePicker placeholder={"日期"} inputReadOnly={true} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name={[index, 'time']}
                            rules={[{ required: item.required, message: '请选择时间' }]}
                        >
                            <TimePicker placeholder={"时间"} inputReadOnly={true} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form.Item>
        /* multi line text input */
        case 3:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <Input.TextArea autoSize={{ minRows: 3 }} placeholder={item.desc} />
            </Form.Item>
        /* single line text input */
        case 4:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <Input placeholder={item.desc} />
            </Form.Item>
        /* number input */
        case 5:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <InputNumber placeholder={item.desc} style={{ width: '100%' }} />
            </Form.Item>
        /* drop down list */
        case 6:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请选择内容' }]}
            >
                <Select placeholder={item.desc}>
                    {JSON.parse(item.content).map((item, index) => {
                        return <Select.Option key={index} value={item.label}>{item.label}</Select.Option>
                    })}
                </Select>
            </Form.Item>
        /* 身份证 ()*/
        case 20:
            return <Form.Item
                key={index}
                label={item.name}
                required={item.required}
            >
                <Row gutter={[16, 16]}>
                    <Col span={16} >
                        <Form.Item
                            name={[index, 'ic']}
                            rules={[{ required: item.required, message: '请输入身份证号码' }, { len: 18, message: '请输入18位身份证号码' }]}
                        >
                            <Input placeholder={'身份证号码'} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={[index, 'name']}
                            rules={[{ required: item.required, message: '请输入身份证姓名' }]}
                        >
                            <Input placeholder={'身份证姓名'} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form.Item>
        /* 生日 */
        case 21:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请选择日期' }]}
            >
                <DatePicker placeholder={item.desc} inputReadOnly={true} style={{ width: '100%' }} />
            </Form.Item>
        /* 标题 */
        case 22:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <Input placeholder={item.desc} />
            </Form.Item>
        /* 内容 */
        case 23:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <Input.TextArea autoSize={{ minRows: 3 }} placeholder={item.desc} />
            </Form.Item>
        /* video link */
        case 24:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请上传视频' }]}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                    if (Array.isArray(e)) { return e; }
                    return e && e.fileList;
                }}
            >
                <UploadDragger accept="video/*" maxCount={1} placeholder="上传视频,最大不超过20M,格式mp4,avi,mov" />
            </Form.Item>
        /* image file */
        case 25:
            return <Form.Item
                key={'1' + index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请上传图片' }]}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                    console.log(e)
                    if (Array.isArray(e)) { return e; }
                    return e && e.fileList;
                }}
            >
                <UploadDragger accept="image/*" listType="picture" maxCount={3} placeholder="上传图片,最大不能超过20M,格式png,jpg,gif" />
            </Form.Item>
        /* game role, platform + server + role_id */
        case 26:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                {/* <GameRole placeholder={item.desc} /> */}
                <Input placeholder={item.desc} />
            </Form.Item>
        /* email */
        case 27:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入邮箱' }, { type: 'email', message: '请输入正确的邮箱地址' }]}
            >
                <Input placeholder={item.desc} />
            </Form.Item>
        /* province + city */
        case 28:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请选择地址' }]}
            >
                <CitySelect placeholder={item.desc} />
            </Form.Item>
        /* IM contact */
        case 29:
            return <Form.Item
                key={index}
                name={index}
                label={item.name}
                rules={[{ required: item.required, message: '请输入信息' }]}
            >
                <Input placeholder={item.desc} />
            </Form.Item>
        /* phone number */
        case 30:
            return <Form.Item
                key={index}
                label={item.name}
                required={item.required}
            >
                <Row gutter={[16, 16]}>
                    <Col span={24} >
                        <Form.Item
                            name={[index, 'phone']}
                            rules={[
                                { required: item.required, message: '缺少手机号码' },
                                { pattern: /^1\d{10}$/, message: '手机号格式错误，请重新输入' }]}
                        >
                            <InputNumber min={1} precision={0} placeholder={'手机号码'} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name={[index, 'code']}
                            rules={[{ required: item.required, message: '缺少验证码' }]}
                        >
                            <Input placeholder={'验证码'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <PhoneCodeButton formName={[index, 'phone']} form={form} />
                    </Col>
                </Row>
            </Form.Item>
        default:
            return null
    }
}

export default AntdFormContent;
